import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AppComponent } from '../app.component';
import { DataserviceService } from '../dataservice.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
})
export class DocumentUploadComponent implements OnInit {
  documents: any[] = [];
  companies: any[] = [];
  providers: any[] = [];
  currentUser: any;
  spinner: boolean = false;

  token: any;

  addModal: boolean = false;
  addForm: FormGroup;

  editing: any;
  loadedDoc: any;

  constructor(
    private app: AppComponent,
    private modalService: NzModalService,
    private dataService: DataserviceService,
    private message: NzMessageService
  ) {

    this.addForm = new FormGroup({
      'company': new FormControl(null, [Validators.required]),
      'provider': new FormControl(null, [Validators.required]),
      'assignType': new FormControl(null, [Validators.required])
    });

  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);

    this.getAllDocs()

    if (this.currentUser?.super_admin) {
      this.getCompanies();
      this.getAllDocs();
      this.getProviders();
    } else {
      this.getCompanyDetails();
      this.getDocumentsByCompany();
    }
  }

  hasPermission(permissions: string): boolean {
    return this.app.hasPermission(permissions);
  }

  async getCompanyDetails() {
    this.dataService.getData(`company/associated-company-info/${this.currentUser?.company_id}/${false}`)
      .subscribe({
        next: (res: any) => {
          if (res?.result == 'success') {
            this.providers = res?.data.providers
          }
        }
      })

  }

  docusealSave(event: any) {
    if (event?.fields?.length > 0) {
      if (this.editing) {
        this.token = null;
        this.addForm.reset();
        this.addModal = false;
        this.editing = false;
        this.getAllDocs();
      } else {
        if (this.addForm.valid) {
          const id = this.message.loading('Assigning documents, this could take a while..', { nzDuration: 0 }).messageId;
          let obj = {
            id: event.id,
            slug: event.slug,
            name: event.name,
            company_id: this.addForm.get('company')?.value,
            provider_id: this.addForm.get('provider')?.value,
            assign_type: this.addForm.get('assignType')?.value
          }

          this.dataService.postData(obj, `templates/create`)
            .subscribe({
              next: (res: any) => {
                if (res?.result == 'success') {
                  setTimeout(() => {
                    this.message.remove(id)
                  }, 1000);
                  this.token = null;
                  this.addForm.reset();
                  this.addModal = false;
                  this.editing = false;
                  if (this.currentUser?.super_admin) {
                    this.getAllDocs();
                  } else {
                    this.getDocumentsByCompany();
                  }
                }
              }
            })
        } else {
          alert('Please fill out all required fields')
        }
      }
    } else {
      alert('At least one field is required to save doc')
    }
  }

  handleCancel() {
    if (this.editing) {
      this.token = null;
      this.addForm.reset();
      this.addModal = false;
      this.editing = false;
    } else {
      this.modalService.confirm({
        nzTitle: '<i>Are you sure you want to close?</i>',
        nzContent: '<b>Doing so will make you lose all progress!</b>',
        nzOnOk: () => {
          this.dataService.postData({ id: this.loadedDoc }, `templates/delete-bad-doc`)
            .subscribe({
              next: (res: any) => {
                this.token = null;
                this.addForm.reset();
                this.addModal = false;
                this.editing = false;
              }
            })
        }
      });
    }
  }

  getCompanies() {
    this.dataService.getData('company')
      .subscribe({
        next: (res: any) => {
          this.companies = res?.data;
        },
        error: (err: any) => {
          console.log('error on get all companies: ', err)
          // this.errorNotification('Failed to get all companies')
        }
      })
  }

  getProviders() {
    this.dataService.getData('providers')
      .subscribe({
        next: (res: any) => {
          this.providers = res?.data || [];
        },
        error: (err: any) => {
          console.log('err from getProviders: ', err)
          // this.errorNotification('Failed to get providers!');
        }
      })
  }

  getAllDocs() {
    this.spinner = true;
    this.dataService.getData(`templates/all-docs`)
      .subscribe({
        next: (res: any) => {

          this.documents = res?.docs;
          this.spinner = false;
        },
        error: (err: any) => {
          console.log('error get docs by company: ', err)
          this.spinner = false;
        }
      })
  }

  getDocumentsByCompany() {
    this.spinner = true;
    this.dataService.getData(`templates/company-docs/${this.currentUser?.company_id}`)
      .subscribe({
        next: (res: any) => {
          this.documents = res?.docs;
          this.spinner = false;
        },
        error: (err: any) => {
          console.log('error get docs by company: ', err)
          this.spinner = false;
        }
      })
  }

  showModal(): void {
    this.addForm.get('company')?.setValue(this.currentUser?.company_id)


    this.dataService.postData({}, 'templates/builder-token')
      .subscribe({
        next: (res: any) => {
          this.token = res?.token;
          this.addModal = true;
        }
      });

  }

  editDoc(doc: any) {
    this.addForm.patchValue({
      company: doc.company_id,
      provider: doc.provider_id,
      assignType: doc.assign_type
    })
    this.dataService.postData({ slug: doc.fileId }, 'templates/update-token')
      .subscribe({
        next: (res: any) => {
          this.editing = true;
          this.token = res?.token;
          this.addModal = true;
        }
      });
  }

  loadDoc(event: any) {
    this.loadedDoc = event.id;
  }

  toggleDocumentStatus(document: any) {
    this.dataService.postData({ id: document.id }, `templates/toggle-status`)
      .subscribe({
        next: (res: any) => {
          if (res?.result == 'success') {
            document.status = res.status;
            this.message.success('Document status updated');
          } else {
            this.message.error('Failed to update document status');
          }
        },
        error: (err: any) => {
          console.log('error toggling document status: ', err)
          this.message.error('Failed to update document status');
        }
      })
  }

}
